export default "__VITE_ASSET__jH1$NQxA__"